var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1015.44 691.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-bg,.cls-2-bg,.cls-6-bg{fill:none;}.cls-1-bg,.cls-4-bg,.cls-5-bg{stroke:#ffc300;}.cls-1-bg,.cls-2-bg,.cls-3-bg,.cls-4-bg,.cls-5-bg,.cls-6-bg{stroke-miterlimit:10;}.cls-1-bg,.cls-2-bg,.cls-3-bg,.cls-4-bg,.cls-5-bg{stroke-width:2px;}.cls-2-bg,.cls-3-bg,.cls-6-bg{stroke:#ff3b83;}.cls-3-bg,.cls-5-bg,.cls-7-bg{fill:#402e82;}.cls-4-bg{fill:#d74f81;}.cls-6-bg{stroke-width:2.13px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Umeboshi",
    "data-name": "Background Umeboshi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_3",
    "data-name": "Livello 3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-bg",
    x: 115.88,
    y: 418.28,
    width: 5.02,
    height: 6.26,
    transform: "translate(-141.41 69.12) rotate(-20.71)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-bg",
    x1: 94.49,
    y1: 443.84,
    x2: 86.08,
    y2: 390.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 83.7,
    y1: 375.13,
    x2: 83.01,
    y2: 370.32
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "83.04 381.1 82.06 374.64 85.02 374.16 85.99 380.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1-bg",
    points: "81.76 380.76 87.05 379.9 88.91 390.86 83.61 391.72 81.76 380.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 180.16,
    y1: 508.26,
    x2: 181.8,
    y2: 512.83
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "179.6 502.29 181.87 508.41 179.07 509.48 176.8 503.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1-bg",
    points: "180.93 502.36 175.91 504.27 171.88 493.91 176.89 492 180.93 502.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-bg",
    x1: 150.27,
    y1: 425.46,
    x2: 174.11,
    y2: 492.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M116.45,408.87a29.54,29.54,0,1,1-8.32,3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M118,413a25.18,25.18,0,1,1-8.3,3.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M116.45,408.87a29.54,29.54,0,1,1-8.32,3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M118,413a25.18,25.18,0,1,1-8.3,3.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M573.22,290s30.25,2.71,35.29,38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M553.13,299.91l-3-3.42a1.93,1.93,0,0,0-1.72-.65l-4.53.54a2,2,0,0,1-1.94-3l2.32-3.93a2,2,0,0,0,.09-1.84l-1.92-4.14a2,2,0,0,1,2.23-2.77l4.45,1a2,2,0,0,0,1.79-.48l3.34-3.11a2,2,0,0,1,3.33,1.27l.43,4.54a2,2,0,0,0,1,1.55l4,2.22a2,2,0,0,1-.17,3.54l-4.19,1.82a2,2,0,0,0-1.16,1.43l-.88,4.48A2,2,0,0,1,553.13,299.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M558.4,504.2s-30.26,2.7-35.29,38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M578.48,514.09l3-3.42a2,2,0,0,1,1.73-.66l4.53.55a2,2,0,0,0,1.94-3l-2.32-3.92a2,2,0,0,1-.09-1.84l1.92-4.15a2,2,0,0,0-2.23-2.76l-4.46,1a2,2,0,0,1-1.78-.48l-3.35-3.11a2,2,0,0,0-3.32,1.27l-.43,4.54a2,2,0,0,1-1,1.54l-4,2.22a2,2,0,0,0,.19,3.55l4.19,1.81a2,2,0,0,1,1.16,1.44l.88,4.48A2,2,0,0,0,578.48,514.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M291.44,399.81s12-27.9-16.61-49.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M273.18,412.77l1.57,4.28a2,2,0,0,1-.24,1.83l-2.63,3.73a2,2,0,0,0,1.69,3.13l4.56-.18a2,2,0,0,1,1.66.8l2.74,3.65a2,2,0,0,0,3.49-.64l1.25-4.4a2,2,0,0,1,1.27-1.33l4.32-1.47a2,2,0,0,0,.47-3.52l-3.8-2.53a2,2,0,0,1-.88-1.63l-.06-4.56a2,2,0,0,0-3.2-1.54l-3.59,2.83a2,2,0,0,1-1.82.33l-4.35-1.36A2,2,0,0,0,273.18,412.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-bg",
    points: "196.99 530.79 189.91 555.52 203.27 552.08 200.44 567.79 217.1 540.15 204.28 543.46 208.84 527.75 196.99 530.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-bg",
    points: "437.72 599.1 430.63 623.83 443.99 620.39 441.17 636.11 457.83 608.47 445 611.76 449.57 596.05 437.72 599.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-bg",
    points: "935.63 362.14 942.59 401.19 922.64 393.81 924.5 418.36 903.29 373.33 922.45 380.42 917.92 355.59 935.63 362.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-bg",
    points: "204.66 333.33 198.93 365.4 215.32 359.34 213.79 379.51 231.21 342.52 215.48 348.34 219.19 327.95 204.66 333.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-bg",
    points: "768.43 552.65 742.5 570.41 757.76 577.57 742.85 590.16 780.08 577.13 765.43 570.24 781.97 559 768.43 552.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-bg",
    points: "368.84 210.59 394.78 228.35 379.51 235.52 394.43 248.1 357.2 235.07 371.85 228.18 355.31 216.95 368.84 210.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-bg",
    points: "570.27 224.6 549.75 238.66 561.82 244.33 550.02 254.3 579.49 243.99 567.9 238.53 580.98 229.64 570.27 224.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-bg",
    points: "783.71 414.29 801.16 432.02 788.21 435.27 797.88 447.31 770.94 431.54 783.37 428.41 772.23 417.18 783.71 414.29"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 345.88,
    y: 581.08,
    width: 49.21,
    height: 5.94,
    transform: "translate(-304.47 433.04) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 402.18,
    cy: 559.71,
    r: 3.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 398.14,
    cy: 543.82,
    r: 3.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M380.39,564.45l2.76,2.76-4.42,4.42L376,568.87a3.13,3.13,0,1,1,4.42-4.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M382.92,575.83l4.43-4.42,2.18,2.18A3.13,3.13,0,0,1,385.1,578Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M372.1,572.74l2.76,2.76-4.43,4.43-2.76-2.76a3.13,3.13,0,1,1,4.43-4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M374.63,584.13l4.42-4.43,2.18,2.18a3.13,3.13,0,0,1-4.43,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M363.8,581l2.76,2.76-4.42,4.42-2.76-2.76a3.12,3.12,0,0,1,0-4.42,3.13,3.13,0,0,1,4.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M366.33,592.42l4.43-4.42,2.18,2.18a3.13,3.13,0,0,1-4.44,4.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M355.51,589.33l2.76,2.76-4.44,4.44-2.75-2.76a3.14,3.14,0,1,1,4.43-4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M358,600.73l4.43-4.44,2.18,2.18a3.14,3.14,0,0,1-4.43,4.44Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 61.44,
    cy: 268.92,
    r: 3.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 65.5,
    cy: 281.93,
    r: 3.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 69.56,
    cy: 294.94,
    r: 3.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 73.62,
    cy: 307.95,
    r: 3.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-bg",
    x: 39.95,
    y: 274.48,
    width: 10.84,
    height: 4.66,
    transform: "translate(-93.23 32.94) rotate(-20.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-bg",
    x: 43.64,
    y: 284.75,
    width: 10.84,
    height: 4.66,
    transform: "translate(-96.57 34.86) rotate(-20.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-bg",
    x: 47.34,
    y: 295.03,
    width: 10.84,
    height: 4.66,
    transform: "translate(-99.9 36.78) rotate(-20.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-bg",
    x: 51.04,
    y: 305.3,
    width: 10.84,
    height: 4.66,
    transform: "translate(-103.24 38.7) rotate(-20.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 352.39,
    y: 543.68,
    width: 20.24,
    height: 6.72,
    transform: "translate(-280.64 416.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 312.19,
    y: 556.09,
    width: 20.22,
    height: 6.72,
    transform: "translate(-301.19 391.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M312.78,564.22l14.3-14.29,4.75,4.75L317.53,569Zm-.64-32.85h0c-.13.15-.27.29-.4.42a32,32,0,0,1-45.31,0c-1.48-1.48-2.42-3.23-4.85-5.87-3.27-3.58-6.65-2.75-9.43-.5-.17.16-.88.85-1,1-4.79,5.72-1.5,17.37,7.63,26.51,8.89,8.88,19.93,12.32,25.81,8.11l.53-.37c6.07-4,11.73.45,18.45,7.16s10.08,13.46,7.05,18.35L309,588.8c-6.14,10.53-.86,24.17,11.06,36.09,10.5,10.5,24.34,14.58,34.67,11.21,0,0,.41-.11,1.13-.34a38.23,38.23,0,0,0,15.08-9.32l46.23-46.23a27.12,27.12,0,0,0,5.91-8.79s0,0,0,0a.48.48,0,0,0,.05-.11c.5-1.21.73-1.89.73-1.89,2.9-8.87-.62-20.72-9.63-29.73-10.35-10.36-22.39-14.46-31.41-8.91l-2.11,1.18c-3.39,1.79-9.91-1-15.38-6.45-5.88-5.89-8.51-11.47-6.38-15.07l.73-1.18c3.56-5.05.45-14.59-7.14-22.17-7.84-7.84-17.88-10.57-22.76-6.46-2.8,2.39-3,6.47-.7,8.6,5.44,4.92,6.77,6.2,6.84,11.35.08,6.19-5.77,12.81-10.68,17.72l-2.53,2.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M74.35,241.09A14.76,14.76,0,0,1,77,258.4s0,0,0,.07c-.24.37-.47.77-.68,1.15,0,0,0,0,0,0a15.1,15.1,0,0,0,15.56,21.92v0a13,13,0,0,1,13.24,18h0a9.49,9.49,0,0,0,2.4,9.28l0,0,223,219.59a3.34,3.34,0,0,1,0,4.73l-5.85,5.84a3.34,3.34,0,0,1-4.73,0L112.78,335.4c-.83-.83-14.66-14.72-28.39-10.21-15,5-21.12-13.2-31.22-43.78-9.7-29.39-1.6-38.24-1-38.9,0,0,0,0,.05,0a11.11,11.11,0,0,1,1.2-1.37A14.77,14.77,0,0,1,74.35,241.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M107.55,309l-.12-.11"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 107.45,
    y1: 308.9,
    x2: 107.43,
    y2: 308.89
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "323.37 114.35 208.7 99.44 208.16 103.59 323.68 118.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M326.65,110.59c.82-.41,2.05.75,2.91.7s2-1.35,2.8-1.06.9,2,1.57,2.56,2.33.41,2.73,1.24-.75,2-.7,2.91,1.35,2,1.06,2.8-2,.9-2.56,1.57-.41,2.33-1.23,2.73-2.06-.75-2.92-.7-2,1.35-2.8,1.06-.9-2-1.57-2.56-2.33-.41-2.73-1.23.75-2.06.7-2.92-1.35-2-1.06-2.8,2-.9,2.56-1.57S325.83,111,326.65,110.59Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "391.36 133.23 480.62 59.72 477.95 56.49 388.02 130.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M391.86,138.2c-.26.88-1.95,1-2.5,1.65s-.37,2.36-1.14,2.77-2.05-.68-2.94-.6-1.89,1.42-2.77,1.15-1-2-1.64-2.5-2.37-.37-2.78-1.15.69-2,.6-2.93-1.42-1.89-1.15-2.77,2-1,2.51-1.65.36-2.36,1.14-2.77,2.05.69,2.93.6,1.89-1.42,2.77-1.15,1,2,1.65,2.5,2.36.37,2.78,1.15-.69,2-.61,2.93S392.13,137.32,391.86,138.2Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 939.31,
    y1: 215.74,
    x2: 935.69,
    y2: 186.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "933.88 171.79 931.44 152.05 921.08 153.34 921.04 153.34 923.48 173.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 928.91,
    y1: 217.03,
    x2: 925.29,
    y2: 187.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M928.91,217c-.95-7.71.6-14.25,3.47-14.61s6,5.61,6.93,13.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M939.31,215.74c.91,7.3-.44,13.54-3,14.5a1.53,1.53,0,0,1-.47.11,1.85,1.85,0,0,1-.47,0c-2.73-.29-5.55-6-6.46-13.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M939.31,215.74c.91,7.3-.44,13.54-3,14.5l-.94.11c-2.73-.29-5.55-6-6.46-13.32"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 931.38,
    cy: 196.49,
    r: 1.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 929.24,
    y1: 219.32,
    x2: 925.32,
    y2: 187.72
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "923.52 173.07 921.08 153.34 921.04 153.34 910.72 154.61 910.68 154.62 913.12 174.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 918.84,
    y1: 220.6,
    x2: 914.93,
    y2: 189
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M918.83,220.6c-1-7.71.59-14.25,3.47-14.61s6,5.61,6.93,13.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M929.23,219.32c.9,7.29-.44,13.53-3,14.49a2,2,0,0,1-.46.12h-.48c-2.73-.3-5.55-6-6.45-13.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M929.23,219.32c.9,7.29-.44,13.53-3,14.49l-.94.12c-2.73-.3-5.55-6-6.45-13.33"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 921.02,
    cy: 197.77,
    r: 1.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 919.2,
    y1: 223.26,
    x2: 914.97,
    y2: 189
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "913.15 174.35 910.72 154.61 910.68 154.62 900.32 155.9 902.75 175.64"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 908.8,
    y1: 224.54,
    x2: 904.57,
    y2: 190.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M908.8,224.55c-.95-7.7.6-14.25,3.47-14.61s6,5.61,6.93,13.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M919.2,223.26c.9,7.29-.44,13.53-3,14.49a1.73,1.73,0,0,1-.46.12,1.85,1.85,0,0,1-.47,0c-2.74-.3-5.55-6-6.46-13.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M919.2,223.26c.9,7.29-.44,13.53-3,14.49l-.93.12c-2.74-.3-5.55-6-6.46-13.33"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 910.65,
    cy: 199.06,
    r: 1.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "909.37 229.13 908.8 224.54 904.57 190.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "902.75 175.64 900.32 155.9 889.92 157.18 892.35 176.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 898.96,
    y1: 230.41,
    x2: 894.17,
    y2: 191.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M899,230.41c-1-7.7.6-14.25,3.48-14.61s6,5.61,6.92,13.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M909.36,229.13c.91,7.29-.43,13.53-3,14.49a1.91,1.91,0,0,1-.47.12h-.47c-2.73-.3-5.55-6-6.45-13.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M909.36,229.13c.91,7.29-.43,13.53-3,14.49l-.94.12c-2.73-.3-5.55-6-6.45-13.33"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 901.86,
    cy: 213.34,
    r: 1.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 900.86,
    cy: 205.29,
    r: 1.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "899.15 231.94 898.97 230.41 894.17 191.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "892.35 176.92 889.92 157.18 879.52 158.47 881.95 178.21"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 888.95,
    y1: 234.75,
    x2: 883.77,
    y2: 192.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M889,234.75c-1-7.7.59-14.25,3.47-14.61s6,5.61,6.93,13.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M899.35,233.47c.9,7.29-.44,13.53-3,14.49a2,2,0,0,1-.46.12,1.93,1.93,0,0,1-.48,0c-2.73-.3-5.55-6-6.45-13.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M899.35,233.47c.9,7.29-.44,13.53-3,14.49l-.94.12c-2.73-.3-5.55-6-6.45-13.33"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 891.46,
    cy: 214.63,
    r: 1.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 890.46,
    cy: 206.59,
    r: 1.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "889.42 238.57 888.95 234.75 883.77 192.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "881.95 178.21 879.52 158.47 869.12 159.76 871.56 179.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 879.02,
    y1: 239.85,
    x2: 873.37,
    y2: 194.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M879,239.85c-.95-7.71.6-14.25,3.47-14.61s6,5.61,6.93,13.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M889.42,238.57c.9,7.29-.44,13.53-3,14.49a1.83,1.83,0,0,1-.46.12h-.47c-2.74-.3-5.56-6-6.46-13.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M889.42,238.57c.9,7.29-.44,13.53-3,14.49l-.93.12c-2.74-.3-5.56-6-6.46-13.33"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 881.07,
    cy: 215.91,
    r: 1.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 880.07,
    cy: 207.87,
    r: 1.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "879.39 242.9 879.02 239.85 873.37 194.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "871.56 179.49 869.12 159.76 858.72 161.04 861.16 180.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 868.99,
    y1: 244.18,
    x2: 862.97,
    y2: 195.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M869,244.19c-1-7.7.6-14.25,3.47-14.61s6,5.61,6.93,13.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M879.39,242.91c.9,7.29-.44,13.53-3,14.49a1.91,1.91,0,0,1-.47.12h-.47c-2.74-.3-5.55-6-6.46-13.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M879.39,242.91c.9,7.29-.44,13.53-3,14.49l-.94.12c-2.74-.3-5.55-6-6.46-13.33"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 872.04,
    cy: 225.19,
    r: 1.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 871.05,
    cy: 217.15,
    r: 1.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 870.05,
    cy: 209.11,
    r: 1.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "869.46 248 868.99 244.18 862.97 195.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "861.16 180.78 858.72 161.04 848.32 162.33 850.76 182.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 859.06,
    y1: 249.29,
    x2: 852.57,
    y2: 196.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M859.06,249.29c-.95-7.71.6-14.25,3.48-14.61s6,5.61,6.92,13.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M869.46,248c.91,7.3-.44,13.54-3,14.5a1.53,1.53,0,0,1-.47.11,1.85,1.85,0,0,1-.47,0c-2.73-.29-5.55-6-6.45-13.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M869.46,248c.91,7.3-.44,13.54-3,14.5l-.94.11c-2.73-.29-5.55-6-6.45-13.32"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 860.88,
    cy: 226.58,
    r: 1.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 859.88,
    cy: 218.53,
    r: 1.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 858.89,
    cy: 210.48,
    r: 1.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 859.06,
    y1: 249.29,
    x2: 852.57,
    y2: 196.72
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "850.76 182.07 848.32 162.33 837.92 163.61 840.36 183.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 848.67,
    y1: 250.57,
    x2: 842.17,
    y2: 198
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M848.66,250.57c-.95-7.7.6-14.25,3.48-14.61s6,5.61,6.92,13.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M859.06,249.29c.91,7.29-.43,13.53-3,14.49a1.91,1.91,0,0,1-.47.12,3.68,3.68,0,0,1-.47,0c-2.73-.3-5.55-6-6.45-13.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M859.06,249.29c.91,7.29-.43,13.53-3,14.49l-.94.12c-2.73-.3-5.55-6-6.45-13.33"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 850.48,
    cy: 227.86,
    r: 1.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 849.49,
    cy: 219.81,
    r: 1.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 848.49,
    cy: 211.78,
    r: 1.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 848.67,
    y1: 250.57,
    x2: 842.17,
    y2: 198
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "840.36 183.35 837.92 163.61 827.52 164.9 829.96 184.64"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 838.27,
    y1: 251.86,
    x2: 831.77,
    y2: 199.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M838.26,251.86c-1-7.71.6-14.26,3.48-14.61s6,5.61,6.92,13.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M848.66,250.57c.91,7.3-.43,13.54-3,14.5a1.89,1.89,0,0,1-.47.11,1.85,1.85,0,0,1-.47,0c-2.73-.3-5.55-6-6.45-13.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M848.66,250.57c.91,7.3-.43,13.54-3,14.5l-.94.11c-2.73-.3-5.55-6-6.45-13.32"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 840.08,
    cy: 229.14,
    r: 1.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 839.09,
    cy: 221.1,
    r: 1.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 838.09,
    cy: 213.06,
    r: 1.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-bg",
    x: 827.78,
    y: 177.83,
    width: 109.75,
    height: 14.76,
    transform: "translate(-16.06 109.71) rotate(-7.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 253.54,
    cy: 264.48,
    r: 2.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 300.39,
    cy: 272.73,
    r: 2.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 287.14,
    cy: 270.4,
    r: 2.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 268.56,
    cy: 267.12,
    r: 2.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M303.34,311.45a12.28,12.28,0,0,0-.54-3.14c-.52-1.53-1.35-2.56-2.42-2.74-2.23-.39-4.72,2.95-5.81,7.65-.08.37-.16.74-.23,1.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 294.42,
    y1: 314.35,
    x2: 303.05,
    y2: 315.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M294.42,314.35a11.24,11.24,0,0,0,.14-1.13c.4-4.81-2.19-9.06-6.1-9.74-4.22-.75-8.39,2.91-9.32,8.17l15.2,2.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M260.37,308.35l18.76,3.3a9.53,9.53,0,1,0-18.76-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M237.31,299.82a12,12,0,0,1,1.59-2.76c1-1.27,2.14-1.94,3.21-1.75,2.23.39,3.43,4.39,2.85,9.18-.05.37-.1.75-.17,1.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 244.7,
    y1: 305.59,
    x2: 236.06,
    y2: 304.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M244.7,305.59c.07-.37.16-.75.26-1.11,1.27-4.66,5.14-7.77,9.06-7.07,4.22.75,6.9,5.61,6,10.87l-15.21-2.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M278.75,311.59,260,308.28a9.53,9.53,0,1,1,18.76,3.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1-bg",
    points: "304.4 316.1 235.01 303.88 236.84 300.63 237.29 299.82 238.03 298.5 238.04 298.49 238.84 297.05 258.65 261.64 296.62 268.33 304.4 316.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M353.15,180.6l-43.91,84a8.58,8.58,0,0,1-1.5,2.06,8.39,8.39,0,0,1-7.4,2.33l-4.59-.81-13-2.28-8.1-1.43-16.89-3-.68-.12a8.38,8.38,0,0,1-5.2-3.14h0a8.3,8.3,0,0,1-1.68-4l-.23-1.67h0l-12.33-92.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "309.29 242 309.24 242.93 309.2 243.45 308.57 253.51 307.74 266.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "303.7 268.9 303.66 268.89 308.57 253.51 308.61 253.41 310.64 247"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "331.49 176.79 308.56 254.03 313.41 173.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "290.71 238.72 288.97 266.31 285.07 265.62 292.07 243.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "312.9 173.52 289.99 250.76 294.83 170.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "272.13 235.45 270.39 263.04 266.49 262.35 273.49 240.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "294.32 170.24 271.4 247.48 276.25 167.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "254.9 237.18 252.85 243.58 252.81 243.7 249.99 252.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "251.89 258.24 252.81 243.7 253.54 232.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "275.73 166.97 252.82 244.21 257.67 163.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M355.77,181.06,236.08,160a4.28,4.28,0,0,1-3.48-5l1.7-9.66a4.27,4.27,0,0,1,5-3.48L359,163a4.28,4.28,0,0,1,3.48,5l-1.7,9.66A4.29,4.29,0,0,1,355.77,181.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 138.6,
    cy: 254.14,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 174.57,
    cy: 260.48,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 164.4,
    cy: 258.69,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 150.13,
    cy: 256.18,
    r: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M176.84,290.21a10,10,0,0,0-.42-2.4c-.4-1.18-1-2-1.86-2.11-1.71-.3-3.62,2.27-4.46,5.87-.06.28-.12.57-.17.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 169.99,
    y1: 292.44,
    x2: 176.62,
    y2: 293.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M170,292.44a8.58,8.58,0,0,0,.1-.87c.31-3.7-1.68-6.95-4.68-7.49-3.24-.57-6.44,2.24-7.16,6.29l11.67,2.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M143.85,287.83l14.4,2.54a7.31,7.31,0,1,0-14.4-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M126.13,281.28a9.53,9.53,0,0,1,1.22-2.11,2.77,2.77,0,0,1,2.47-1.34c1.72.3,2.63,3.37,2.19,7,0,.29-.08.57-.13.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 131.81,
    y1: 285.71,
    x2: 125.19,
    y2: 284.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M131.81,285.71a8.08,8.08,0,0,1,.2-.85c1-3.58,4-6,7-5.43,3.24.57,5.29,4.31,4.58,8.35l-11.67-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M158,290.32l-14.4-2.54a7.31,7.31,0,1,1,14.4,2.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1-bg",
    points: "177.65 293.78 124.38 284.4 125.78 281.9 126.13 281.27 126.69 280.26 126.7 280.26 127.31 279.15 142.52 251.97 171.68 257.11 177.65 293.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M215.07,189.75l-33.7,64.49a6.09,6.09,0,0,1-1.16,1.58,6.46,6.46,0,0,1-3.09,1.72,6.39,6.39,0,0,1-2.58.07L171,257l-10-1.76-6.22-1.09-13-2.29-.52-.09a6.45,6.45,0,0,1-4-2.41h0a6.45,6.45,0,0,1-1.3-3.08l-.17-1.29h0l-9.46-70.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "181.41 236.88 181.36 237.6 181.33 238 180.85 245.73 180.21 255.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "177.11 257.54 177.08 257.53 180.85 245.73 180.88 245.65 182.44 240.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "198.44 186.82 180.85 246.12 184.57 184.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "167.14 234.37 165.8 255.55 162.81 255.02 168.18 238.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "184.17 184.31 166.58 243.61 170.3 181.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "152.87 231.86 151.53 253.04 148.54 252.51 153.91 235.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "169.91 181.79 152.31 241.09 156.03 179.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "139.64 233.2 138.07 238.1 138.04 238.2 135.88 244.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "137.34 249.35 138.04 238.2 138.6 229.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "155.64 179.28 138.04 238.58 141.77 176.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M217.09,190.11l-91.9-16.19a3.29,3.29,0,0,1-2.67-3.81l1.31-7.42a3.29,3.29,0,0,1,3.81-2.67l91.9,16.19a3.29,3.29,0,0,1,2.67,3.81l-1.31,7.42A3.3,3.3,0,0,1,217.09,190.11Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 247.56,
    y1: 234.28,
    x2: 196.5,
    y2: 225.29
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "252.95 241.96 252.95 241.98 252.92 241.97"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 248.48,
    y1: 241.19,
    x2: 193.27,
    y2: 231.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 253.36,
    y1: 235.31,
    x2: 253.34,
    y2: 235.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M603.64,606.92v1.85a21.15,21.15,0,0,0,35.67,15.39h0c.1-.1.2-.2.31-.29h0a14.88,14.88,0,0,1,22.94,3.24h0a21.23,21.23,0,0,0,4.85,5.53h0a22.8,22.8,0,0,0,13.37,4.66H681c16.4,0,29.7-18.95,29.7-42.31s-13.3-42.32-29.7-42.32v.09h-.32A21.16,21.16,0,0,0,662.52,563h0a14.89,14.89,0,0,1-22.88,3.19h0l-.33-.33h0a21.15,21.15,0,0,0-35.65,15.41v.46m22.19,20.65a14,14,0,1,1,11.44,5.94A13.91,13.91,0,0,1,625.83,602.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M680.67,637.28a21,21,0,0,1-13.24-4.66,22.79,22.79,0,0,0,13.36,4.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1-bg",
    points: "611.72 581.45 611.72 607.16 531.09 604.69 531.09 583.94 611.72 581.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M485,620.26h12.51a6.26,6.26,0,0,1-12.51,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M505.6,620.26h12.51a6.26,6.26,0,0,1-12.51,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M485,568.84h12.51a6.26,6.26,0,0,0-12.51,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M505.6,568.84h12.51a6.26,6.26,0,0,0-12.51,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M637.28,580.31A14,14,0,1,1,625,587.63,13.94,13.94,0,0,1,637.28,580.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 683.2,
    y: 572.49,
    width: 8.8,
    height: 43.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 678.29,
    y1: 572.49,
    x2: 678.29,
    y2: 616.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M531.09,604.7,520,612.78H478.15V611h0c4.5-.56,7.94-3.7,7.94-7.5s-3.44-6.93-7.94-7.5h0V594.3"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 495.8,
    cy: 603.54,
    r: 1.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 510.02,
    cy: 603.54,
    r: 1.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M531.09,583.86,520,575.78H478.15v1.74h0c4.5.57,7.94,3.71,7.94,7.5s-3.44,6.94-7.94,7.5h0v1.74"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 495.8,
    cy: 585.02,
    r: 1.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 510.02,
    cy: 585.02,
    r: 1.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 473.92,
    y1: 181.63,
    x2: 442.25,
    y2: 189.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 485.63,
    y1: 219.76,
    x2: 450.44,
    y2: 228.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 485.44,
    y1: 198.77,
    x2: 440.45,
    y2: 210.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-bg",
    x1: 481.32,
    y1: 189.78,
    x2: 439.7,
    y2: 200.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-bg",
    x1: 487.08,
    y1: 208.41,
    x2: 443.66,
    y2: 219.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 554.63,
    y1: 166.4,
    x2: 523.4,
    y2: 156.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 544.51,
    y1: 204.98,
    x2: 509.82,
    y2: 194.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 555.41,
    y1: 187.05,
    x2: 511.04,
    y2: 173.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-bg",
    x1: 556.63,
    y1: 177.23,
    x2: 515.61,
    y2: 164.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-bg",
    x1: 551.73,
    y1: 196.11,
    x2: 508.91,
    y2: 182.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M485.92,200.45a34.11,34.11,0,0,1-1.59,22.66,0,0,0,0,0,0,0,50.72,50.72,0,0,0-3.76,18.62c-.3,10.63,2.24,20.09,5.94,24.57a1.71,1.71,0,0,0,.18.2,13.74,13.74,0,0,1,2.88,5.6c1.58,6.09-1,12-5.77,13.26s-9.91-2.72-11.47-8.81a13.6,13.6,0,0,1-.09-6.67c1.16-5.68-1.24-15-6.69-24.27a51.28,51.28,0,0,0-12-14.23l-.11-.09-.74-.54s0,0-.06,0a34.37,34.37,0,0,1-11.81-18.67c-4.11-15.93,2.64-31.46,15.09-34.67S481.81,184.51,485.92,200.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M554.94,188.72a34.11,34.11,0,0,1-13.28,18.43h0a50.68,50.68,0,0,0-13,13.86c-5.85,8.88-8.67,18.26-7.89,24,0,.1,0,.18,0,.26a13.92,13.92,0,0,1-.49,6.28c-1.88,6-7.2,9.69-11.89,8.23s-7-7.52-5.12-13.53a13.79,13.79,0,0,1,3.43-5.71c4-4.21,6.87-13.42,7.1-24.15A51.07,51.07,0,0,0,511.13,198a.5.5,0,0,0-.05-.13c-.11-.29-.22-.57-.34-.85a.25.25,0,0,0,0-.07,34.32,34.32,0,0,1-.22-22.08c4.9-15.72,18.81-25.36,31.09-21.53S559.82,173,554.94,188.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 609.45,
    y: 10.44,
    width: 8.82,
    height: 22.24,
    transform: "translate(499.97 625.15) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "757.81 79.78 758.58 74.71 758.89 72.71 760.15 64.47"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 774.41,
    y1: 82.31,
    x2: 775.18,
    y2: 77.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 775.49,
    y1: 75.24,
    x2: 776.74,
    y2: 67.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 773.98,
    y: 71.88,
    width: 2.8,
    height: 8.96,
    transform: "translate(582.97 831.35) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 739.72,
    y1: 77.03,
    x2: 740.94,
    y2: 69.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 740.8,
    y1: 69.95,
    x2: 742.06,
    y2: 61.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3-bg",
    x: 740.49,
    y: 58.73,
    width: 2.8,
    height: 8.96,
    transform: "translate(567.53 787.08) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3-bg",
    x: 758.08,
    y: 64.71,
    width: 2.8,
    height: 8.96,
    transform: "translate(576.56 809.55) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "706.74 71.99 707.51 66.92 707.82 64.92 709.08 56.68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 723.34,
    y1: 74.52,
    x2: 724.11,
    y2: 69.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 724.41,
    y1: 67.45,
    x2: 725.67,
    y2: 59.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 722.9,
    y: 64.09,
    width: 2.8,
    height: 8.96,
    transform: "translate(547.3 774.25) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 688.66,
    y1: 69.23,
    x2: 689.43,
    y2: 64.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 689.73,
    y1: 62.16,
    x2: 690.99,
    y2: 53.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 688.22,
    y: 58.8,
    width: 2.8,
    height: 8.96,
    transform: "translate(523.08 735.47) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 631.55,
    y1: 37.85,
    x2: 628.3,
    y2: 59.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 611.43,
    y: 48.33,
    width: 3.22,
    height: 12.03,
    transform: "translate(466.87 652.18) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 586.38,
    y: 44.51,
    width: 3.22,
    height: 12.03,
    transform: "translate(449.38 624.18) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 811.81,
    cy: 79.87,
    r: 2.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 794.91,
    cy: 77.29,
    r: 2.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 656.88,
    cy: 56.23,
    r: 2.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 712.14,
    cy: 36.6,
    r: 2.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 698.54,
    cy: 34.53,
    r: 2.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 684.95,
    cy: 32.46,
    r: 2.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 671.35,
    cy: 30.38,
    r: 2.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 657.76,
    cy: 28.31,
    r: 2.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 644.17,
    cy: 26.24,
    r: 2.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 639.98,
    cy: 53.65,
    r: 2.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 614.14,
    cy: 46.73,
    r: 2.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4-bg",
    cx: 816.63,
    cy: 52.52,
    r: 2.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4-bg",
    cx: 592.9,
    cy: 18.38,
    r: 2.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 589.15,
    cy: 42.92,
    r: 2.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 804.56,
    y1: 91.39,
    x2: 795.57,
    y2: 150.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 787.92,
    y1: 88.84,
    x2: 778.92,
    y2: 147.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 771.28,
    y1: 86.31,
    x2: 762.28,
    y2: 145.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 754.63,
    y1: 83.76,
    x2: 745.63,
    y2: 142.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 737.98,
    y1: 81.23,
    x2: 728.98,
    y2: 140.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 721.33,
    y1: 78.68,
    x2: 712.34,
    y2: 137.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 704.68,
    y1: 76.15,
    x2: 695.69,
    y2: 135.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 688.04,
    y1: 73.6,
    x2: 679.04,
    y2: 132.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 671.4,
    y1: 71.07,
    x2: 662.4,
    y2: 130.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 654.75,
    y1: 68.52,
    x2: 645.75,
    y2: 127.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 638.1,
    y1: 65.99,
    x2: 629.11,
    y2: 124.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5-bg",
    x: 755.44,
    y: 96.68,
    width: 27.43,
    height: 6.26,
    transform: "translate(554.5 845.12) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5-bg",
    x: 788.85,
    y: 101.78,
    width: 27.43,
    height: 6.26,
    transform: "translate(577.84 882.48) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5-bg",
    x: 738.96,
    y: 94.16,
    width: 27.43,
    height: 6.26,
    transform: "translate(543 826.69) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5-bg",
    x: 705.62,
    y: 89.08,
    width: 27.43,
    height: 6.26,
    transform: "translate(519.71 789.41) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5-bg",
    x: 689.02,
    y: 86.55,
    width: 27.43,
    height: 6.26,
    transform: "translate(508.11 770.85) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5-bg",
    x: 672.27,
    y: 83.99,
    width: 27.43,
    height: 6.26,
    transform: "translate(496.42 752.12) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5-bg",
    x: 639.09,
    y: 78.94,
    width: 27.43,
    height: 6.26,
    transform: "translate(473.24 715.03) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5-bg",
    x: 622.38,
    y: 76.39,
    width: 27.43,
    height: 6.26,
    transform: "translate(461.56 696.35) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 587.32,
    y1: 30.5,
    x2: 817.63,
    y2: 65.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 595.91,
    y1: 96.84,
    x2: 603.35,
    y2: 97.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 597.84,
    y1: 84.23,
    x2: 605.28,
    y2: 85.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 577.98,
    y1: 94.1,
    x2: 585.41,
    y2: 95.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 579.9,
    y1: 81.49,
    x2: 587.34,
    y2: 82.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-bg",
    x: 585.41,
    y: 87.22,
    width: 30.53,
    height: 7.52,
    transform: "matrix(0.15, -0.99, 0.99, 0.15, 420.15, 671.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-bg",
    x: 567.48,
    y: 84.49,
    width: 30.53,
    height: 7.52,
    transform: "translate(407.63 651.02) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-bg",
    x1: 572.92,
    y1: 56.04,
    x2: 820.92,
    y2: 93.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 562.47,
    y: 65.04,
    width: 59.65,
    height: 48.18,
    transform: "translate(414.87 661.21) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 639.1,
    y: -48.47,
    width: 115.16,
    height: 250.88,
    transform: "translate(515.53 754.08) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3-bg",
    x: 707.02,
    y: 56.92,
    width: 2.8,
    height: 8.96,
    transform: "translate(540.89 752.46) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M714.21,450s4.46,23.49,35.24,23.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M778,487.08l-4.54.34a2,2,0,0,0-1.57,1l-2.3,4a2,2,0,0,1-3.55-.25l-1.73-4.23a2,2,0,0,0-1.4-1.18l-4.46-1a2,2,0,0,1-.86-3.45l3.49-2.95a2,2,0,0,0,.7-1.71l-.46-4.54a2,2,0,0,1,3-1.88l3.88,2.4a2,2,0,0,0,1.84.14l4.18-1.83a2,2,0,0,1,2.72,2.28l-1.09,4.44a2,2,0,0,0,.45,1.79l3,3.4A2,2,0,0,1,778,487.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M353.54,123.59s-5.3-23.32,22.76-36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M401.66,76.56l-4.54-.43a2,2,0,0,1-1.55-1l-2.22-4a2,2,0,0,0-3.54.17L388,75.48a2,2,0,0,1-1.43,1.16l-4.48.87a2,2,0,0,0-.93,3.44l3.42,3a1.94,1.94,0,0,1,.65,1.72l-.54,4.54a2,2,0,0,0,3,1.94l3.93-2.32a2,2,0,0,1,1.84-.09l4.14,1.92a2,2,0,0,0,2.77-2.22l-1-4.46a2,2,0,0,1,.48-1.78l3.1-3.34A2,2,0,0,0,401.66,76.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M674.59,459.11s-9.18,31.75,23.13,47.43c20.36,9.88,24.77,24.15,20.79,37.19"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 714.76,
    y: 394,
    width: 10.47,
    height: 16.45,
    transform: "translate(83.29 926.41) rotate(-68.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M681.12,324.77c31,8.54,50.64,35.3,40.47,72.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M704.63,429.14a78.77,78.77,0,0,0,13.58-22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M681.12,324.77c31,8.54,50.64,35.3,40.47,72.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M704.63,429.14a78.77,78.77,0,0,0,13.58-22"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 659.67,
    y: 429.22,
    width: 47.46,
    height: 12.28,
    transform: "translate(-34.43 811.25) rotate(-60.14)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-bg",
    points: "680.45 452.77 693.3 460.14 713.62 433.49 697 423.95 680.45 452.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M660.5,452.31l4.56,2.62,26.05-45.38-4.56-2.62a7,7,0,0,0-9.6,2.6L657.9,442.71A7,7,0,0,0,660.5,452.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M717.31,395.57s18.3-50-37.33-67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M613.62,367s9.9-52.33,66.36-38.41"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 602.7,
    y: 363.19,
    width: 10.47,
    height: 16.45,
    transform: "translate(141.68 910.06) rotate(-80.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M609.17,366.26c10.29-37.11,40.89-50,71.86-41.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M609.81,366.89a78.45,78.45,0,0,0,.4,25.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M609.17,366.26c10.29-37.11,40.89-50,71.86-41.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M684.45,312.66c31,8.53,49.47,39.52,37.14,84.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M609.17,366.26c12.47-45,44.22-62.15,75.2-53.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M607,376.51a78.4,78.4,0,0,0,.4,25.85"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 598.82,
    y: 412.34,
    width: 47.46,
    height: 12.28,
    transform: "translate(193.98 1034.13) rotate(-89.07)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-bg",
    points: "616.07 435.04 601.26 434.79 597.45 401.49 616.61 401.81 616.07 435.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M633.44,444.86l-5.25-.08.85-52.31,5.26.08a7,7,0,0,1,6.92,7.14l-.63,38.25A7,7,0,0,1,633.44,444.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-bg",
    x: 602.69,
    y: 366.5,
    width: 10.47,
    height: 9.83,
    transform: "translate(141.67 910.06) rotate(-80.54)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-bg",
    x: 717.66,
    y: 395.25,
    width: 10.47,
    height: 9.83,
    transform: "translate(87.05 927.81) rotate(-68.65)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6-bg",
    cx: 880.49,
    cy: 484.22,
    r: 2.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6-bg",
    cx: 868.98,
    cy: 487.25,
    r: 2.35
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-bg",
    points: "518.21 4.96 501.61 37.13 521 36.07 512.76 56.98 543.38 23.44 524.77 24.45 535.4 4.03 518.21 4.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-bg",
    points: "902.17 67.97 861.66 94.76 885.05 106.22 861.7 125.3 919.55 106.09 897.09 95.08 922.92 78.13 902.17 67.97"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 917,
    cy: 646.01,
    r: 2.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 902.54,
    cy: 649.81,
    r: 2.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 945.89,
    cy: 638.41,
    r: 2.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 931.44,
    cy: 642.21,
    r: 2.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 917,
    cy: 646.01,
    r: 2.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 848.91,
    y1: 433.17,
    x2: 868.21,
    y2: 516.22
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "843.59 366.94 834.09 369.43 848.91 433.17 868.21 516.22"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 895.61,
    y1: 509.02,
    x2: 871.55,
    y2: 427.21
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "843.59 366.94 853.1 364.43 871.55 427.21 895.61 509.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M843.59,366.93,834,369.46l-1.46-5.54a5.72,5.72,0,0,0-7-4.09L820,361.29l-9.08-34.5a16,16,0,0,1,11.45-19.6l5.18-1.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M843.59,366.93l9.62-2.52-1.46-5.55a5.73,5.73,0,0,1,4.08-7l5.55-1.46-9.08-34.5a16.05,16.05,0,0,0-19.6-11.44l-5.18,1.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-bg",
    x1: 819.98,
    y1: 361.28,
    x2: 825.52,
    y2: 359.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 821.82,
    cy: 329.5,
    r: 2.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 824.67,
    cy: 340.3,
    r: 2.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 827.51,
    cy: 351.1,
    r: 2.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 843.61,
    cy: 323.78,
    r: 2.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 846.44,
    cy: 334.58,
    r: 2.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 849.29,
    cy: 345.37,
    r: 2.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M806.49,339.37l-3.5.91a1.66,1.66,0,0,1-2-1.18l-1.41-5.35a1.68,1.68,0,0,1,1.19-2l3.49-.92a1.68,1.68,0,0,1,2,1.18l1.41,5.36A1.67,1.67,0,0,1,806.49,339.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M809.62,351.27l-3.5.92a1.68,1.68,0,0,1-2-1.18l-1.41-5.36a1.67,1.67,0,0,1,1.19-2l3.5-.92a1.66,1.66,0,0,1,2,1.18l1.41,5.35A1.66,1.66,0,0,1,809.62,351.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M812.75,363.18l-3.5.92a1.69,1.69,0,0,1-2-1.18l-1.4-5.36a1.67,1.67,0,0,1,1.18-2l3.5-.92a1.68,1.68,0,0,1,2,1.19l1.41,5.35A1.65,1.65,0,0,1,812.75,363.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M865.16,323.93l-3.49.92a1.68,1.68,0,0,1-2-1.19l-1.41-5.35a1.68,1.68,0,0,1,1.18-2l3.5-.92a1.68,1.68,0,0,1,2,1.19l1.41,5.35A1.68,1.68,0,0,1,865.16,323.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M868.3,335.84l-3.5.92a1.67,1.67,0,0,1-2-1.18l-1.41-5.36a1.67,1.67,0,0,1,1.19-2l3.49-.92a1.66,1.66,0,0,1,2,1.18l1.41,5.35A1.67,1.67,0,0,1,868.3,335.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M871.43,347.75l-3.5.92a1.68,1.68,0,0,1-2-1.18l-1.41-5.36a1.68,1.68,0,0,1,1.19-2l3.5-.92a1.67,1.67,0,0,1,2,1.19l1.41,5.35A1.66,1.66,0,0,1,871.43,347.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 840.81,
    y: 519.21,
    width: 6.8,
    height: 3.31,
    transform: "translate(-104.71 231.81) rotate(-14.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M848.85,517.82l-10,2.63a3.21,3.21,0,0,1-3.92-2.28l0-.1,16.23-4.27,0,.1A3.22,3.22,0,0,1,848.85,517.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M895.61,509h-.05M849.84,689.17l-.13,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M965.15,570.36a15.86,15.86,0,0,1-17-12.05,16.23,16.23,0,0,1,8.47-18.66A22.88,22.88,0,0,0,968.12,513c-3.46-12-16.18-18.77-28.24-15.59L895.62,509l12.31,41.88L893,554.82a19.21,19.21,0,1,1-13.68,23.46A19.21,19.21,0,0,1,893,554.82l-14.91,3.92-9.88-42.52L823.9,527.87c-12.12,3.19-19.84,15.43-16.87,27.6a22.87,22.87,0,0,0,23.09,17.45A16.24,16.24,0,0,1,846.68,585a15.86,15.86,0,0,1-8.86,18.84,44.69,44.69,0,0,0-3.09,80.42v0a55.14,55.14,0,0,0,16.6,5.19,82.1,82.1,0,0,0,34.52-1.73L964.62,667a82,82,0,0,0,30.66-15.28l1.38-1.13.1-.08a52.19,52.19,0,0,0,10.64-11.64h0a44.68,44.68,0,0,0-42.26-68.48Zm-17.82,10.21L928.7,610.69l-8.37,13.52,2.84-12.46,3.56-15.63L908.12,601,907,596.85a24.24,24.24,0,0,0,17.18-29.61,23.9,23.9,0,0,0-4.49-9l20.34-5.35-7.76,31.59Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "928.7 610.69 920.33 624.21 923.17 611.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M932.31,584.52l15-3.95L928.7,610.69l-8.37,13.52,2.84-12.46,3.56-15.63L908.12,601,907,596.85a24.24,24.24,0,0,0,17.18-29.61,23.9,23.9,0,0,0-4.49-9l20.34-5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M932.31,584.52l15-3.95L928.7,610.69l-8.37,13.52,2.84-12.46,3.56-15.63L908.12,601,907,596.85a24.24,24.24,0,0,0,17.18-29.61,23.9,23.9,0,0,0-4.49-9l20.34-5.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M940.07,552.93l-20.34,5.35A24.27,24.27,0,0,1,907,596.84l1.09,4.17,18.61-4.9-3.56,15.63-2.84,12.46,8.37-13.52,18.63-30.12-15,4Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "422.57 169.84 434.19 173.26 438.33 161.87 449.95 165.29 454.1 153.9 465.72 157.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "963.26 450.38 951.24 448.95 949.04 460.86 937.02 459.42 934.82 471.33 922.8 469.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "891.9 320.99 903.52 317.59 900.87 305.77 912.49 302.37 909.84 290.56 921.46 287.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "950.14 130.27 945.02 141.24 955.65 147.05 950.52 158.02 961.15 163.83 956.03 174.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "536.8 126.86 539.84 138.58 551.73 136.29 554.77 148.02 566.66 145.73 569.7 157.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "749.06 180.35 747.11 192.31 758.93 195.03 756.98 206.99 768.8 209.7 766.86 221.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "653.47 172.95 663.43 176.23 664.14 165.77 674.11 169.06 674.83 158.58 684.8 161.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "648.08 267.19 650.64 279.04 662.62 277.25 665.18 289.09 677.17 287.31 679.74 299.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "226.65 600.09 233.76 609.89 244 603.41 251.1 613.22 261.34 606.74 268.46 616.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "556.5 536.99 563.61 546.79 573.85 540.32 580.96 550.12 591.2 543.64 598.32 553.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "419.24 504.7 420.68 516.73 432.77 516.04 434.21 528.07 446.31 527.4 447.76 539.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-bg",
    points: "765.06 346.92 755.26 354.03 761.73 364.27 751.93 371.38 758.41 381.62 748.6 388.73"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 681.66,
    cy: 267.37,
    r: 6.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 660.36,
    cy: 244.07,
    r: 6.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 661.78,
    cy: 212.54,
    r: 6.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 685.08,
    cy: 191.24,
    r: 6.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 716.61,
    cy: 192.66,
    r: 6.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 737.91,
    cy: 215.96,
    r: 6.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 736.49,
    cy: 247.49,
    r: 6.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 713.19,
    cy: 268.79,
    r: 6.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5-bg",
    cx: 699.13,
    cy: 230.01,
    r: 43.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3-bg",
    cx: 699.13,
    cy: 230.01,
    r: 38.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M117.72,525.29l-3.54-6.15C115.38,521.23,116.56,523.29,117.72,525.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M81.16,522.19l2.5,4.35m-.25,20.94,30.34,52.75A9.75,9.75,0,1,1,96.85,610L39.11,509.57a24.87,24.87,0,0,1,4.81-30.74l24.76,43.05M72,527.65,74.51,532m12.39.18,2.51,4.35M145,635.76l-1.87-3.24a2.51,2.51,0,0,1,.67-3.26c5.83-4.3,8.35-11.25,6-16.77h0s-9-23.61-31.41-64.72l-36.21-63a24.9,24.9,0,0,0-29-11.3l24.76,43m68.49,121.74,47.7-27.44M5,404.85l3.9-2.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M95.75,439.3v0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7-bg",
    d: "M105.21,524.91c4.84,8.34,9.18,15.59,13.15,22.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-bg",
    points: "92.17 522.31 94.81 520.81 97.48 525.46 94.83 526.96 92.17 522.31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 83.11,
    y: 514.59,
    width: 5,
    height: 2.64,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -245.84, 111.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 88.86,
    y: 524.58,
    width: 5,
    height: 2.64,
    transform: "translate(-250.05 115.59) rotate(-29.91)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-bg",
    points: "86.42 512.32 89.06 510.82 91.73 515.47 89.09 516.97 86.42 512.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-bg",
    points: "97.73 532.06 100.38 530.56 103.06 535.21 100.41 536.71 97.73 532.06"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 94.42,
    y: 534.33,
    width: 5,
    height: 2.64,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -254.17, 119.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M92.65,542.16l30.09,52.32c5.51,9.58,2.77,22-6.59,27.89a20.43,20.43,0,0,1-28.54-7.1L29.87,514.89a35.54,35.54,0,0,1,8.65-45.45l-21.28-37,1.2-.69,7.3-4.2.73-.42,21.28,37A35.54,35.54,0,0,1,91.38,479.5l22.8,39.64c1.2,2.09,2.37,4.15,3.54,6.15C147.09,576,167.3,601.22,167.94,602h0c3.94,5.28,12.34,6.35,19.48,2.25a2.52,2.52,0,0,1,3.44.93l1.79,3.12"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 71.2,
    y: 540.17,
    width: 25.36,
    height: 6.5,
    transform: "translate(-259.79 114.2) rotate(-29.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 65.45,
    y: 530.19,
    width: 25.36,
    height: 6.5,
    transform: "translate(-255.58 110) rotate(-29.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 59.71,
    y: 520.21,
    width: 25.36,
    height: 6.5,
    transform: "translate(-251.36 105.81) rotate(-29.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-bg",
    x: 138.72,
    y: 621.97,
    width: 61.3,
    height: 2.92,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -288.29, 167.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-bg",
    x: 12.24,
    y: 401.74,
    width: 4.49,
    height: 30.01,
    transform: "translate(-205.87 62.72) rotate(-29.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M1.37,403.29l7.68-4.42.92,1.59a1.33,1.33,0,0,1-.5,1.83l-5.35,3.08a1.33,1.33,0,0,1-1.83-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M53.16,473.51a29.24,29.24,0,0,0-9.24,5.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-bg",
    d: "M47.76,464.12a40,40,0,0,0-9.24,5.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-bg",
    points: "222.26 236.58 215.29 235.35 206.88 227.12 213.85 228.35 222.26 236.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-bg",
    points: "229.3 237.81 222.33 236.59 213.92 228.36 220.89 229.58 229.3 237.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2-bg",
    points: "236.14 239.01 229.17 237.79 220.76 229.56 227.73 230.78 236.14 239.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1-bg",
    points: "119.59 417.2 111.2 420.38 107.33 410.21 115.73 407.03 119.59 417.2"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 418.58,
    cy: 406.5,
    r: 51.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 418.58,
    cy: 406.5,
    r: 16.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-bg",
    cx: 418.58,
    cy: 406.5,
    r: 49.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M389,444.56a48.23,48.23,0,0,1-18.17-31.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M406.52,451.7a46.74,46.74,0,0,1-33.16-57.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M390.73,442.38a45.5,45.5,0,0,1-17.13-29.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M407.27,448.91a43.86,43.86,0,0,1-31.12-53.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M392.52,440.07a42.6,42.6,0,0,1-16-27.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M408.05,446.11A41,41,0,0,1,379,396"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M394.35,437.71A39.49,39.49,0,0,1,379.46,412"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M408.76,443.3a38.07,38.07,0,0,1-27-46.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M396.13,435.42a36.59,36.59,0,0,1-13.8-23.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M409.53,440.4a35,35,0,0,1-24.87-42.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M398,433.06a33.62,33.62,0,0,1-12.68-21.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M410.28,437.56a32.13,32.13,0,0,1-22.79-39.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M399.72,430.79a30.83,30.83,0,0,1-11.6-20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M411,434.83A29.3,29.3,0,0,1,390.23,399"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M401.51,428.48A27.91,27.91,0,0,1,391,410.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M411.77,431.93a26.3,26.3,0,0,1-18.65-32.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M403.33,426.13a25.19,25.19,0,0,1-6.26-7.16,24.73,24.73,0,0,1-3.1-9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M412.54,429.08A23.34,23.34,0,0,1,396,400.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M405.06,423.89a22.1,22.1,0,0,1-8.3-14.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M413.27,426.31a20.47,20.47,0,0,1-14.52-25.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M406.8,421.65a19.24,19.24,0,0,1-7.22-12.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M414,423.57A17.64,17.64,0,0,1,401.49,402"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M389,444.56a48.23,48.23,0,0,1-18.17-31.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M406.52,451.7a46.74,46.74,0,0,1-33.16-57.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M390.73,442.38a45.5,45.5,0,0,1-17.13-29.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M407.27,448.91a43.86,43.86,0,0,1-31.12-53.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M392.52,440.07a42.6,42.6,0,0,1-16-27.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M408.05,446.11A41,41,0,0,1,379,396"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M394.35,437.71A39.49,39.49,0,0,1,379.46,412"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M408.76,443.3a38.07,38.07,0,0,1-27-46.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M396.13,435.42a36.59,36.59,0,0,1-13.8-23.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M409.53,440.4a35,35,0,0,1-24.87-42.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M398,433.06a33.62,33.62,0,0,1-12.68-21.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M410.28,437.56a32.13,32.13,0,0,1-22.79-39.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M399.72,430.79a30.83,30.83,0,0,1-11.6-20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M411,434.83A29.3,29.3,0,0,1,390.23,399"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M401.51,428.48A27.91,27.91,0,0,1,391,410.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M411.77,431.93a26.3,26.3,0,0,1-18.65-32.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M403.33,426.13a25.19,25.19,0,0,1-6.26-7.16,24.73,24.73,0,0,1-3.1-9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M412.54,429.08A23.34,23.34,0,0,1,396,400.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M405.06,423.89a22.1,22.1,0,0,1-8.3-14.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M413.27,426.31a20.47,20.47,0,0,1-14.52-25.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M406.8,421.65a19.24,19.24,0,0,1-7.22-12.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M414,423.57A17.64,17.64,0,0,1,401.49,402"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M448.07,368.46a48.28,48.28,0,0,1,18.16,31.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M430.59,361.32a46.74,46.74,0,0,1,33.16,57.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M446.38,370.64a45.32,45.32,0,0,1,11.44,13.1,45.79,45.79,0,0,1,5.69,16.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M429.84,364.11A43.87,43.87,0,0,1,461,417.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M444.59,372.94a42.66,42.66,0,0,1,16,27.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M429.06,366.92a41,41,0,0,1,29.08,50.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M442.76,375.31A39.67,39.67,0,0,1,457.65,401"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M428.35,369.72a38.05,38.05,0,0,1,27,46.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M441,377.6a36.69,36.69,0,0,1,13.79,23.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M427.58,372.62a35,35,0,0,1,24.87,42.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M439.15,380a33.69,33.69,0,0,1,12.68,21.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M426.82,375.46a32.11,32.11,0,0,1,22.79,39.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M437.39,382.23a30.83,30.83,0,0,1,11.59,20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M426.1,378.2A29.29,29.29,0,0,1,446.89,414"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M435.61,384.54a27.67,27.67,0,0,1,7,8,28,28,0,0,1,3.49,10.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M425.33,381.09A26.3,26.3,0,0,1,444,413.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M433.78,386.9A24.89,24.89,0,0,1,443.14,403"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M424.58,383.93a23.34,23.34,0,0,1,16.56,28.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M432,389.13a22,22,0,0,1,5.55,6.34,22.31,22.31,0,0,1,2.76,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M423.83,386.71a20.48,20.48,0,0,1,14.53,25.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M430.3,391.37a19.19,19.19,0,0,1,7.23,12.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M423.1,389.46A17.63,17.63,0,0,1,435.62,411"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M448.07,368.46a48.28,48.28,0,0,1,18.16,31.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M430.59,361.32a46.74,46.74,0,0,1,33.16,57.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M446.38,370.64a45.32,45.32,0,0,1,11.44,13.1,45.79,45.79,0,0,1,5.69,16.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M429.84,364.11A43.87,43.87,0,0,1,461,417.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M444.59,372.94a42.66,42.66,0,0,1,16,27.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M429.06,366.92a41,41,0,0,1,29.08,50.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M428.35,369.72a38.05,38.05,0,0,1,27,46.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M439.15,380a33.69,33.69,0,0,1,12.68,21.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M426.82,375.46a32.11,32.11,0,0,1,22.79,39.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M437.39,382.23a30.83,30.83,0,0,1,11.59,20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M426.1,378.2A29.29,29.29,0,0,1,446.89,414"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M425.33,381.09A26.3,26.3,0,0,1,444,413.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M433.78,386.9A24.89,24.89,0,0,1,443.14,403"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M424.58,383.93a23.34,23.34,0,0,1,16.56,28.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M432,389.13a22,22,0,0,1,5.55,6.34,22.31,22.31,0,0,1,2.76,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M423.83,386.71a20.48,20.48,0,0,1,14.53,25.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M430.3,391.37a19.19,19.19,0,0,1,7.23,12.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M423.1,389.46A17.63,17.63,0,0,1,435.62,411"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-bg",
    x: 497.29,
    y: 393.15,
    width: 10.8,
    height: 7.15,
    transform: "translate(-9.87 780.62) rotate(-75.11)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1-bg",
    points: "514.72 394.38 502.26 441.24 475.6 464.72 470.7 459.16 495.68 437.16 507.56 392.47 514.72 394.38"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 398.87,
    cy: 473.16,
    r: 2.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 424.96,
    cy: 480.1,
    r: 2.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 451.05,
    cy: 487.03,
    r: 2.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 409.96,
    y: 311.54,
    width: 5.74,
    height: 18.78,
    transform: "translate(-3.38 637.45) rotate(-75.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-bg",
    x: 512.71,
    y: 338.85,
    width: 5.74,
    height: 18.78,
    transform: "translate(46.57 757.05) rotate(-75.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M495.31,506.58,350.74,468.15A20.8,20.8,0,0,1,336,442.71l28.88-108.65A20.81,20.81,0,0,1,390.3,319.3l144.58,38.44a20.8,20.8,0,0,1,14.76,25.44L520.75,491.82A20.79,20.79,0,0,1,495.31,506.58Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-bg",
    x1: 413.59,
    y1: 318.19,
    x2: 412.22,
    y2: 323.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-bg",
    x1: 516.34,
    y1: 345.51,
    x2: 514.97,
    y2: 350.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-bg",
    x: 380.89,
    y: 333.16,
    width: 123.72,
    height: 159.76,
    transform: "translate(-70.17 734.82) rotate(-75.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 359.39,
    cy: 447.02,
    r: 2.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 499.1,
    cy: 484.16,
    r: 2.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 527.04,
    cy: 379.07,
    r: 2.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-bg",
    cx: 387.34,
    cy: 341.94,
    r: 2.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-bg",
    d: "M558.37,355.14,375.65,306.57l3.67-13.84a12.78,12.78,0,0,1,15.62-9.06l158.06,42a12.76,12.76,0,0,1,9,15.61Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBg);
export default __webpack_public_path__ + "static/media/home-bg.0ff42e1f0a6a7dfbb69f42e5ed6a2758.svg";
export { ForwardRef as ReactComponent };